import * as React from "react";

const ArrowRight = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={16}
    stroke={props.color}
    viewBox="0 0 28 23"
    {...props}
  >
    <path
      fill={props.color}
      d="M27.577 11.542a2.006 2.006 0 0 0 .069-.311v-.017a.676.676 0 0 0-.069-.311.789.789 0 0 0-.19-.276L17.02.259a.867.867 0 0 0-1.227 1.226l8.9 8.884H.864a.863.863 0 1 0 0 1.726h23.828l-8.9 8.884a.854.854 0 0 0 0 1.226.868.868 0 0 0 .6.259A.839.839 0 0 0 17 22.2l10.37-10.347a2.189 2.189 0 0 0 .19-.276Z"
    />
  </svg>
)
export default ArrowRight;

